"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _cardModule = _interopRequireDefault(require("./card.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcCard(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_cardModule["default"].wrapper)
  }, /*#__PURE__*/_react["default"].createElement(_lib.Card, {
    activeTabKey: props.activeTabKey,
    bodyStyle: props.bodyStyle,
    bordered: props.bordered,
    cover: props.cover,
    headStyle: props.headStyle,
    hoverable: props.hoverable,
    loading: props.loading,
    tabBarExtraContent: props.tabBarExtraContent,
    tabList: props.tabList,
    type: props.type,
    onTabChange: props.onTabChange,
    className: props.className ? 'card' : '',
    description: props.description,
    size: props.size
  }));
}
var _default = ArcCard;
exports["default"] = _default;